import { MobilePage } from "./MobilePage";
import MobileStepOne from "../../containers/stepsMobile/MobileStepOne";
import MobileStepTwo from "../../containers/stepsMobile/MobileStepTwo";
import MobileStepThree from "../../containers/stepsMobile/MobileStepThree";
import MobileStepFour from "../../containers/stepsMobile/MobileStepFour";

export const MOBILE_PAGES = {
  1: <MobileStepOne />,
  2: <MobileStepTwo />,
  3: <MobileStepThree />, // me
  4: <MobileStepFour />
};

export default MobilePage;
